import { CommonModule, UpperCasePipe } from '@angular/common';
import { Component, input } from '@angular/core';
import { TranslatePipe } from '@ngx-translate/core';
import { SummaryOfTheYearTop } from '@agilox/common';
import { IconModule } from '@agilox/ui';
import { RankingStyleClassesPipe } from './ranking-style-classes.pipe';

@Component({
	selector: 'multiple-vehicles-slide',
	templateUrl: './multiple-vehicles-slide.component.html',
	imports: [CommonModule, TranslatePipe, UpperCasePipe, IconModule, RankingStyleClassesPipe],
	host: {
		'[class.absolute]': 'true',
		'[class.w-full]': 'true',
		'[class.h-full]': 'true',
		'[class.right-0]': 'currentSlideIndex() < startSlideIndex()',
		'[class.translate-x-full]': 'currentSlideIndex() < startSlideIndex()',
		'[class.left-0]': 'currentSlideIndex() >= startSlideIndex()',
		'[class.transition-all]':
			'currentSlideIndex() === startSlideIndex() || currentSlideIndex() === startSlideIndex() + 1',
		'[class.-translate-x-full]': 'currentSlideIndex() > startSlideIndex() + 1',
		'[class.duration-1000]': 'true',
		'[class.ease-in-out]': 'true',
	},
})
export class MultipleVehiclesSlideComponent {
	icon = input<string>('');
	slideTitle = input<string>('');
	values = input<SummaryOfTheYearTop[]>([]);
	startSlideIndex = input<number>(0);
	currentSlideIndex = input<number>(0);
}
